module.exports = __webpack_public_path__ + "8df7ece6e444468cd53101caec490a6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-768.jpg
// module id = 217
// module chunks = 0